(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nri-card-sketch-enhancer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function getConfig(root) {
    var config = root.querySelector('.rwnri-image-config') || document.querySelector('.rwnri-image-config');
    return config ? config.dataset : null;
  }

  function addImage(card, src, alt) {
    if (!card || !src || card.querySelector('.rwnri-card-image')) return;

    var wrap = document.createElement('div');
    wrap.className = 'rwnri-card-image-wrap';

    var image = document.createElement('img');
    image.className = 'rwnri-card-image';
    image.src = src;
    image.alt = alt || '';
    image.width = 720;
    image.height = 480;
    image.loading = 'lazy';
    image.decoding = 'async';

    wrap.appendChild(image);
    card.insertBefore(wrap, card.firstChild);
  }

  function wrapArticle(card, destination, imageSrc, imageAlt) {
    if (!card) return;

    var heading = card.querySelector('h3');
    var label = heading ? heading.textContent.trim() : 'NRI interior service';
    addImage(card, imageSrc, imageAlt || label);

    if (card.parentElement && card.parentElement.classList.contains('rwnri-card-link')) {
      card.parentElement.href = destination;
      card.parentElement.setAttribute('aria-label', label);
      return;
    }

    var wrapper = document.createElement('a');
    wrapper.className = 'rwnri-card-link';
    wrapper.href = destination;
    wrapper.setAttribute('aria-label', label);
    card.parentNode.insertBefore(wrapper, card);
    wrapper.appendChild(card);
  }

  function enhanceNriCards(scope) {
    var root = scope.querySelector ? scope.querySelector('.rwnri') : null;
    if (!root && scope !== document) root = document.querySelector('.rwnri');
    if (!root) return;

    var images = getConfig(document);
    if (!images) return;

    var indiaExecution = root.querySelector('.rwnri-navy');
    if (indiaExecution && !indiaExecution.id) indiaExecution.id = 'india-execution';
    var inquiry = root.querySelector('#nri-inquiry');
    if (inquiry) inquiry.style.scrollMarginTop = '90px';
    if (indiaExecution) indiaExecution.style.scrollMarginTop = '90px';

    var groups = root.querySelectorAll('.rwnri-cards');
    var processDestinations = ['#nri-inquiry', '#nri-inquiry', '#india-execution', '#nri-inquiry'];
    var processImages = [images.remoteConsultation, images.digitalApprovals, images.localCoordination, images.progressHandover];
    var processAlt = [
      'Remote interior consultation for an NRI-owned Bengaluru home',
      'Digital interior design approvals for an NRI home project',
      'Local interior project coordination in Bengaluru',
      'Interior project progress review and home handover'
    ];
    var propertyDestinations = ['/pages/residential-interiors', '#nri-inquiry', '#nri-inquiry', '/pages/interior-services'];
    var propertyImages = [images.selfUseHome, images.rentalReady, images.investmentProperty, images.remoteRenovation];
    var propertyAlt = [
      'Complete interior planning for an NRI self-use home in Bengaluru',
      'Rental-ready apartment interior planning in Bengaluru',
      'Interior planning for an NRI investment property in Bengaluru',
      'Remote renovation planning for a Bengaluru home'
    ];

    if (groups[0]) {
      groups[0].querySelectorAll('article').forEach(function (card, index) {
        wrapArticle(card, processDestinations[index] || '#nri-inquiry', processImages[index], processAlt[index]);
      });
    }

    if (groups[1]) {
      groups[1].querySelectorAll('article').forEach(function (card, index) {
        wrapArticle(card, propertyDestinations[index] || '#nri-inquiry', propertyImages[index], propertyAlt[index]);
      });
    }

    var serviceImages = [
      images.completeHome,
      images.modularKitchen,
      images.wardrobes,
      images.studyRoom,
      images.remoteRenovation,
      images.remoteConsultation
    ];
    var serviceAlt = [
      'Complete home interior planning in Bengaluru',
      'Modular kitchen interior design',
      'Wardrobe interior design and storage planning',
      'Study room and work table interior planning',
      'Home renovation and interior service planning',
      'Contact Right Work for an NRI interior project'
    ];
    var serviceDestinations = [
      '/pages/residential-interiors',
      '/collections/modular-kitchen',
      '/collections/wardrobe',
      '/collections/office-furniture-rw',
      '/pages/interior-services',
      '/pages/contact-us'
    ];

    root.querySelectorAll('.rwnri-services a').forEach(function (card, index) {
      var heading = card.querySelector('strong');
      var label = heading ? heading.textContent.trim() : 'Interior service';
      if (serviceDestinations[index]) card.href = serviceDestinations[index];
      addImage(card, serviceImages[index], serviceAlt[index] || label);
    });
  }

  function init() {
    enhanceNriCards(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhanceNriCards(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["right-work-footer-v8"] && !Shopify.designMode) return;
  try {
    
(() => {
  const desktop = window.matchMedia('(min-width: 760px)');
  const mobileState = new WeakMap();

  const syncFooterGroups = () => {
    document.querySelectorAll('.footer-premium-v8 details.footer-group-v8').forEach((group) => {
      if (desktop.matches) {
        if (!mobileState.has(group)) mobileState.set(group, group.open);
        group.open = true;
      } else if (mobileState.has(group)) {
        group.open = mobileState.get(group);
        mobileState.delete(group);
      }
    });
  };

  syncFooterGroups();

  if (desktop.addEventListener) {
    desktop.addEventListener('change', syncFooterGroups);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["right-work-premium-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  try{
  var root = document.querySelector('.rw-product');
  if(!root) return;
  var form = root.querySelector('.rw-form');
  var variantsEl = root.querySelector('[data-rw-variants]');
  var variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]');
  var idInput = root.querySelector('[data-variant-id]');
  var qtyInput = root.querySelector('[data-quantity-input]');
  var qty = root.querySelector('[data-qty]');
  var price = root.querySelector('[data-price]');
  var compare = root.querySelector('[data-compare-price]');
  var discount = root.querySelector('[data-discount]');
  var addBtn = root.querySelector('.rw-btn--primary');
  var buyBtn = root.querySelector('[data-buy-now]');
  var mainImg = root.querySelector('.rw-main-image__img');
  var unavailNote = root.querySelector('[data-unavailable-note]');

  function money(c){
    return new Intl.NumberFormat(undefined,{style:'currency',currency:'INR',maximumFractionDigits:0}).format(c/100);
  }

  function selectedVariant(){
    var checked = root.querySelectorAll('[data-option-position]:checked');
    if(checked.length === 0){
      var currentId = idInput ? idInput.value : null;
      var byId = null;
      variants.forEach(function(v){ if(String(v.id) === String(currentId)){ byId = v; } });
      return byId || (variants.length === 1 ? variants[0] : null);
    }
    var selected = [];
    checked.forEach(function(i){
      selected[Number(i.dataset.optionPosition)-1] = i.value;
    });
    var match = null;
    variants.forEach(function(v){
      if(!match && v.options && v.options.length === selected.length && v.options.every(function(value, i){ return value === selected[i]; })){
        match = v;
      }
    });
    if(match) return match;
    var joined = selected.join(' / ');
    variants.forEach(function(v){ if(!match && v.title === joined){ match = v; } });
    if(match) return match;
    if(selected.length === 1){
      variants.forEach(function(v){ if(!match && v.options && v.options[0] === selected[0]){ match = v; } });
    }
    return match;
  }

  function refresh(){
    var v = selectedVariant();
    if(!v){
      if(addBtn){ addBtn.disabled = true; var s0 = addBtn.querySelector('span'); if(s0){ s0.textContent = 'UNAVAILABLE'; } }
      if(buyBtn){ buyBtn.disabled = true; }
      if(unavailNote){ unavailNote.hidden = false; }
      return;
    }
    if(unavailNote){ unavailNote.hidden = true; }
    idInput.value = v.id;
    price.textContent = money(v.price);
    if(compare && discount){
      if(v.compare_at_price && v.compare_at_price > v.price){
        compare.textContent = money(v.compare_at_price);
        compare.hidden = false;
        discount.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF';
        discount.hidden = false;
      } else {
        compare.hidden = true;
        discount.hidden = true;
      }
    }
    if(addBtn){
      addBtn.disabled = !v.available;
      var s = addBtn.querySelector('span');
      if(s){ s.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT'; }
    }
    if(buyBtn){ buyBtn.disabled = !v.available; }

    if(mainImg && v.featured_image && v.featured_image.src){
      mainImg.src = v.featured_image.src;
      mainImg.removeAttribute('srcset');
    }

    if(window.history && window.history.replaceState){
      try{
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }catch(e){}
    }
  }

  root.querySelectorAll('[data-option-position]').forEach(function(i){
    i.addEventListener('change', function(){
      root.querySelectorAll('.rw-choice').forEach(function(l){ l.classList.remove('is-selected'); });
      root.querySelectorAll('[data-option-position]:checked').forEach(function(x){ x.closest('.rw-choice').classList.add('is-selected'); });
      refresh();
    });
  });

  var qtyMinus = root.querySelector('[data-qty-minus]');
  var qtyPlus = root.querySelector('[data-qty-plus]');
  if(qtyMinus){ qtyMinus.addEventListener('click', function(){
    qty.value = Math.max(1, (parseInt(qty.value)||1) - 1);
    qtyInput.value = qty.value;
  }); }
  if(qtyPlus){ qtyPlus.addEventListener('click', function(){
    qty.value = (parseInt(qty.value)||1) + 1;
    qtyInput.value = qty.value;
  }); }
  if(qty){ qty.addEventListener('input', function(){
    qty.value = Math.max(1, parseInt(qty.value)||1);
    qtyInput.value = qty.value;
  }); }

  root.querySelectorAll('.rw-thumb').forEach(function(t){
    t.addEventListener('click', function(){
      if(mainImg){
        mainImg.src = t.dataset.imageUrl;
        mainImg.removeAttribute('srcset');
      }
      root.querySelectorAll('.rw-thumb').forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  var wishlistBtn = root.querySelector('[data-wishlist]');
  if(wishlistBtn){ wishlistBtn.addEventListener('click', function(e){ e.currentTarget.classList.toggle('is-active'); }); }

  if(buyBtn){ buyBtn.addEventListener('click', function(){
    if(buyBtn.disabled) return;
    qtyInput.value = qty.value;
    var r = document.createElement('input');
    r.type = 'hidden';
    r.name = 'return_to';
    r.value = '/checkout';
    form.appendChild(r);
    if(form.requestSubmit){ form.requestSubmit(); } else { form.submit(); }
  }); }

  var tabButtons = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
  var tabPanels = root.querySelectorAll('[data-panel]');
  function activateTab(tab){
    tabButtons.forEach(function(x){
      var isActive = x === tab;
      x.classList.toggle('is-active', isActive);
      x.setAttribute('aria-selected', isActive ? 'true' : 'false');
      x.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    tabPanels.forEach(function(p){
      var isActive = p.dataset.panel === tab.dataset.tab;
      p.classList.toggle('is-active', isActive);
      p.hidden = !isActive;
    });
  }
  tabButtons.forEach(function(tab){
    tab.addEventListener('click', function(){ activateTab(tab); });
    tab.addEventListener('keydown', function(e){
      var currentIndex = tabButtons.indexOf(tab);
      if(e.key === 'ArrowRight'){
        e.preventDefault();
        var next = tabButtons[(currentIndex + 1) % tabButtons.length];
        next.focus(); activateTab(next);
      } else if(e.key === 'ArrowLeft'){
        e.preventDefault();
        var prev = tabButtons[(currentIndex - 1 + tabButtons.length) % tabButtons.length];
        prev.focus(); activateTab(prev);
      }
    });
  });

  refresh();
  }catch(err){
    if(window.console && console.error){ console.error('RW product section error:', err); }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-blog-page"]) return;
  try {
    
(function(){
  function initSlider(root){
    if(!root || root.dataset.ready==='true')return;
    root.dataset.ready='true';
    var track=root.querySelector('[data-rw-slider-track]');
    var slides=Array.from(root.querySelectorAll('[data-rw-slide]'));
    var prev=root.querySelector('[data-rw-slider-prev]');
    var next=root.querySelector('[data-rw-slider-next]');
    var dotsWrap=root.querySelector('[data-rw-slider-dots]');
    var currentEl=root.querySelector('[data-rw-slider-current]');
    var totalEl=root.querySelector('[data-rw-slider-total]');
    var speed=parseInt(root.dataset.speed||'4500',10);
    var index=0;
    var timer=null;
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!track || slides.length<2)return;

    function pad(n){return String(n).padStart(2,'0')}
    function render(){
      track.style.transform='translate3d(-'+(index*100)+'%,0,0)';
      var dots=Array.from(dotsWrap.children);
      dots.forEach(function(dot,i){
        dot.classList.toggle('is-active',i===index);
        dot.setAttribute('aria-current',i===index?'true':'false');
      });
      if(currentEl)currentEl.textContent=pad(index+1);
    }
    function go(i){
      index=(i+slides.length)%slides.length;
      render();
    }
    function stop(){
      if(timer){window.clearInterval(timer);timer=null}
    }
    function start(){
      stop();
      if(reduced)return;
      timer=window.setInterval(function(){go(index+1)},speed);
    }

    if(totalEl)totalEl.textContent=pad(slides.length);
    slides.forEach(function(slide,i){
      var dot=document.createElement('button');
      dot.type='button';
      dot.setAttribute('aria-label','Show guide '+(i+1));
      dot.addEventListener('click',function(){go(i);start()});
      dotsWrap.appendChild(dot);
    });
    if(prev)prev.addEventListener('click',function(){go(index-1);start()});
    if(next)next.addEventListener('click',function(){go(index+1);start()});
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',start);
    root.addEventListener('focusin',stop);
    root.addEventListener('focusout',start);

    var startX=0;
    root.addEventListener('touchstart',function(e){startX=e.touches[0].clientX},{passive:true});
    root.addEventListener('touchend',function(e){
      var dx=e.changedTouches[0].clientX-startX;
      if(Math.abs(dx)>45){go(dx<0?index+1:index-1);start()}
    },{passive:true});

    render();
    start();
  }

  document.querySelectorAll('[data-rw-journal-slider]').forEach(initSlider);
  document.addEventListener('shopify:section:load',function(event){
    var slider=event.target.querySelector('[data-rw-journal-slider]');
    if(slider)initSlider(slider);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-interior-gallery-editable"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.rwGalleryReady==='true')return;
    root.dataset.rwGalleryReady='true';
    var cards=Array.from(root.querySelectorAll('[data-rw-edit-card]'));
    var tabs=Array.from(root.querySelectorAll('[data-rw-edit-tab]'));
    var categories=['kitchen','wardrobe','living','bedroom','complete-home'];

    categories.forEach(function(category){
      var count=cards.filter(function(card){return card.getAttribute('data-category')===category}).length;
      var counter=root.querySelector('[data-rw-count="'+category+'"]');
      if(counter)counter.textContent=count;
      var tab=root.querySelector('[data-rw-edit-tab="'+category+'"]');
      if(tab && count===0)tab.hidden=true;
    });

    function selectCategory(category){
      tabs.forEach(function(tab){
        var selected=tab.getAttribute('data-rw-edit-tab')===category;
        tab.setAttribute('aria-selected',selected?'true':'false');
      });
      cards.forEach(function(card){card.hidden=card.getAttribute('data-category')!==category});
    }

    var firstVisible=tabs.find(function(tab){return !tab.hidden});
    if(firstVisible)selectCategory(firstVisible.getAttribute('data-rw-edit-tab'));
    tabs.forEach(function(tab){tab.addEventListener('click',function(){selectCategory(tab.getAttribute('data-rw-edit-tab'))})});

    var dialog=root.querySelector('[data-rw-edit-dialog]');
    var main=root.querySelector('[data-rw-edit-main]');
    var title=root.querySelector('[data-rw-edit-title]');
    var desc=root.querySelector('[data-rw-edit-description]');
    var view=root.querySelector('[data-rw-edit-view]');
    var total=root.querySelector('[data-rw-edit-total]');
    var thumbs=root.querySelector('[data-rw-edit-thumbs]');
    var state={images:[],index:0,title:''};

    function update(){
      if(!state.images.length)return;
      var current=state.images[state.index];
      main.src=current.src;
      main.alt=state.title+' - '+current.label;
      view.textContent=current.label+' · '+(state.index+1)+' / '+state.images.length;
      Array.from(thumbs.children).forEach(function(btn,i){btn.setAttribute('aria-current',i===state.index?'true':'false')});
    }

    function openCard(card){
      state.images=[];
      state.index=0;
      state.title=card.getAttribute('data-title')||'Design gallery';
      for(var i=1;i<=4;i++){
        var src=card.getAttribute('data-img-'+i);
        if(src)state.images.push({src:src,label:card.getAttribute('data-label-'+i)||('View '+i)});
      }
      if(!state.images.length)return;
      title.textContent=state.title;
      desc.textContent=card.getAttribute('data-description')||'';
      total.textContent=state.images.length;
      thumbs.innerHTML='';
      state.images.forEach(function(image,i){
        var button=document.createElement('button');
        button.type='button';
        button.setAttribute('aria-label','Show '+image.label);
        var img=document.createElement('img');
        img.src=image.src;
        img.alt='';
        img.loading='lazy';
        button.appendChild(img);
        button.addEventListener('click',function(){state.index=i;update()});
        thumbs.appendChild(button);
      });
      update();
      if(typeof dialog.showModal==='function')dialog.showModal();
    }

    cards.forEach(function(card){card.addEventListener('click',function(){openCard(card)})});
    var close=root.querySelector('[data-rw-edit-close]');
    var prev=root.querySelector('[data-rw-edit-prev]');
    var next=root.querySelector('[data-rw-edit-next]');
    if(close)close.addEventListener('click',function(){dialog.close()});
    if(prev)prev.addEventListener('click',function(){state.index=(state.index-1+state.images.length)%state.images.length;update()});
    if(next)next.addEventListener('click',function(){state.index=(state.index+1)%state.images.length;update()});
    if(dialog){
      dialog.addEventListener('click',function(e){if(e.target===dialog)dialog.close()});
      dialog.addEventListener('keydown',function(e){
        if(e.key==='ArrowLeft'){state.index=(state.index-1+state.images.length)%state.images.length;update()}
        if(e.key==='ArrowRight'){state.index=(state.index+1)%state.images.length;update()}
      });
    }
  }

  document.querySelectorAll('[data-rw-edit-gallery]').forEach(init);
  document.addEventListener('shopify:section:load',function(event){
    var root=event.target.querySelector('[data-rw-edit-gallery]');
    if(root)init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-requirement-calculator"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.rw-simplecalc').forEach(function(root){
    if(root.dataset.ready==='1') return;
    root.dataset.ready='1';

    var activeMode='custom';
    function n(v){return Number(v||0);}
    function money(v){return '₹'+Math.round(v).toLocaleString('en-IN');}
    function camelRate(prefix,value){return n(root.dataset[prefix+value.charAt(0).toUpperCase()+value.slice(1)]);}
    function checked(name){var e=root.querySelector('input[name="'+name+'"]:checked');return e?e.value:'';}

    root.querySelectorAll('[data-mode]').forEach(function(btn){
      btn.addEventListener('click',function(){
        activeMode=btn.dataset.mode;
        root.querySelectorAll('[data-mode]').forEach(function(b){b.classList.toggle('is-active',b===btn);});
        root.querySelectorAll('[data-panel]').forEach(function(p){p.hidden=p.dataset.panel!==activeMode;p.classList.toggle('is-active',p.dataset.panel===activeMode);});
        root.querySelector('[data-result]').hidden=true;
      });
    });

    root.querySelectorAll('[data-service]').forEach(function(box){
      box.addEventListener('change',function(){
        var key=box.dataset.service;
        var line=root.querySelector('[data-line="'+key+'"]');
        if(line) line.hidden=!box.checked;
        var count=root.querySelectorAll('[data-service]:checked').length;
        root.querySelector('[data-empty-note]').hidden=count>0;
        root.querySelector('[data-result]').hidden=true;
      });
    });

    function customTotal(){
      var total=0, labels=[];
      root.querySelectorAll('[data-service]:checked').forEach(function(box){
        var key=box.dataset.service;
        var qEl=root.querySelector('[data-qty="'+key+'"]');
        var q=Math.max(0,n(qEl&&qEl.value));
        var r=0,label='';
        if(key==='kitchen'){var o=root.querySelector('[data-option="kitchen"]').value;r=camelRate('kitchen',o);label='Modular Kitchen · '+o;}
        else if(key==='wardrobe'){var wo=root.querySelector('[data-option="wardrobe"]').value;r=camelRate('wardrobe',wo);label='Wardrobe · '+wo;}
        else if(key==='tv'){var to=root.querySelector('[data-option="tv"]').value;r=camelRate('tv',to);label='TV Unit · '+to;}
        else if(key==='paint'){var po=root.querySelector('[data-option="paint"]').value;r=camelRate('paint',po);label='Painting · '+po;}
        else{r=n(root.dataset[key]);label=key.charAt(0).toUpperCase()+key.slice(1);}
        total+=q*r;
        labels.push(label);
      });
      return {total:total,labels:labels};
    }

    function validateLead(){
      var ok=true;
      ['[data-name]','[data-phone]','[data-city]'].forEach(function(sel){
        var el=root.querySelector(sel);
        el.classList.remove('rw-simplecalc__error');
        if(!el.value.trim()){el.classList.add('rw-simplecalc__error');ok=false;}
      });
      return ok;
    }

    root.querySelector('[data-calculate]').addEventListener('click',function(){
      if(!validateLead()) return;

      var total=0,summary='';
      if(activeMode==='custom'){
        var c=customTotal();
        if(c.total<=0){root.querySelector('[data-empty-note]').hidden=false;return;}
        total=c.total;
        summary=c.labels.join(' · ');
      }else if(activeMode==='home'){
        var h=checked('rw_home')||'2';
        total=n(root.dataset['home'+h]);
        summary=h+' BHK Full Home';
      }else{
        var p=checked('rw_package')||'recommended';
        total=camelRate('package',p);
        summary=p.charAt(0).toUpperCase()+p.slice(1)+' Package';
      }

      var factor=Math.max(.01,n(root.dataset.mrpFactor)||.62);
      var mrp=total/factor;
      var save=Math.max(0,mrp-total);
      var pct=mrp?Math.round(save/mrp*100):0;

      root.querySelector('[data-total]').textContent=money(total);
      root.querySelector('[data-mrp]').textContent=money(mrp);
      root.querySelector('[data-save]').textContent='Approx. '+pct+'% saving';
      root.querySelector('[data-summary]').textContent=summary;

      var name=root.querySelector('[data-name]').value.trim();
      var phone=root.querySelector('[data-phone]').value.trim();
      var city=root.querySelector('[data-city]').value.trim();
      var note=root.querySelector('[data-note]').value.trim();
      var msg='Hi Right Work Interior, I checked my interior estimate online.\n\nName: '+name+'\nPhone: '+phone+'\nLocation: '+city+'\nRequirement: '+summary+'\nIndicative Estimate: '+money(total)+'\n'+(note?'Notes: '+note+'\n':'')+'\nPlease help me with the final offer and blocking my interior slot.';
      root.querySelector('[data-whatsapp]').href='https://wa.me/919880064884?text='+encodeURIComponent(msg);

      var result=root.querySelector('[data-result]');
      result.hidden=false;
      result.scrollIntoView({behavior:'smooth',block:'center'});
    });

    root.querySelectorAll('input,select,textarea').forEach(function(el){
      el.addEventListener('input',function(){root.querySelector('[data-result]').hidden=true;el.classList.remove('rw-simplecalc__error');});
      el.addEventListener('change',function(){root.querySelector('[data-result]').hidden=true;});
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-smart-estimator"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.rw-estimator').forEach(function(root){
    if(root.dataset.simpleReady==='1') return;
    root.dataset.simpleReady='1';

    var dialog=root.querySelector('.rw-estimator__dialog');
    var form=root.querySelector('[data-estimator-form]');
    var title=root.querySelector('[data-estimator-title]');
    var steps=Array.from(root.querySelectorAll('.rw-estimator__step'));
    var progress=Array.from(root.querySelectorAll('.rw-estimator__progress span'));
    var next=root.querySelector('.rw-estimator__next');
    var back=root.querySelector('.rw-estimator__back');
    var close=root.querySelector('.rw-estimator__close');
    var restart=root.querySelector('.rw-estimator__restart');
    var result=root.querySelector('.rw-estimator__result');
    var actions=root.querySelector('.rw-estimator__actions');
    var type='home';
    var step=1;

    var packageRates={essential:550000,recommended:650000,premium:1000000};
    var kitchenRates={laminate:1450,acrylic:2100,pu:3600,veneer:3600};
    var wardrobeRates={laminate:1500,acrylic:1800,pu:2600,veneer:3800};
    var kitchenArea={compact:60,standard:100,large:140};
    var homeSizeFactor={'2bhk':0.8,'3bhk':1,'4bhk':1.4,villa:1.8};
    var qualityFactor={essential:1,recommended:1.08,premium:1.16};

    function money(n){return '₹'+Math.round(n).toLocaleString('en-IN');}
    function checked(name){var el=form.querySelector('input[name="'+name+'"]:checked');return el?el.value:'';}

    function setPanels(){
      root.querySelectorAll('[data-type-panel]').forEach(function(panel){
        panel.hidden=panel.dataset.typePanel!==type;
      });
      title.textContent=type==='home'?'Full Home Estimate':type==='kitchen'?'Kitchen Estimate':'Wardrobe Estimate';
    }

    function showStep(n){
      step=n;
      steps.forEach(function(s,i){s.classList.toggle('is-active',i===n-1);});
      progress.forEach(function(p,i){p.classList.toggle('is-active',i<n);});
      back.disabled=n===1;
      next.textContent=n===3?'Show Estimate':'Next';
      result.hidden=true;
      actions.hidden=false;
    }

    function defaultsFromPackage(pkg){
      if(pkg==='essential') return {material:'plywood',hardware:'standard'};
      if(pkg==='premium') return {material:type==='wardrobe'?'hdhmr':'bwp',hardware:'luxury'};
      return {material:type==='wardrobe'?'hdhmr':'bwp',hardware:'premium'};
    }

    function recommendation(pkg,finish){
      var finishName=finish==='veneer'?(type==='wardrobe'?'Glass / premium finish':'Premium finish'):(finish==='laminate'?'Laminate':finish.toUpperCase());
      if(type==='kitchen') return {title:'BWP plywood carcass + '+finishName+' shutters + '+(pkg==='essential'?'essential':pkg==='premium'?'signature':'premium soft-close')+' hardware',note:'Kitchen estimate uses the selected size as an indicative shutter/front area and your chosen finish rate.'};
      if(type==='wardrobe') return {title:'Optimized plywood / HDHMR specification + '+finishName+' + '+(pkg==='essential'?'essential':pkg==='premium'?'signature':'premium')+' hardware',note:'Wardrobe estimate is calculated from the width × height entered by you.'};
      return {title:(pkg==='essential'?'Essential':pkg==='premium'?'Signature':'Recommended')+' full-home specification with '+finishName+' fronts',note:'Full-home estimate uses the selected package as the base and adjusts it for home size and finish level.'};
    }

    function calculate(){
      var pkg=checked('package')||'recommended';
      var finish=checked('finish')||'laminate';
      var total=0;
      var summary='';

      if(type==='home'){
        var size=checked('home_size')||'2bhk';
        var basePackage=packageRates[pkg]||packageRates.recommended;
        var sizeFactor=homeSizeFactor[size]||1;
        var finishRatio=(kitchenRates[finish]||kitchenRates.laminate)/kitchenRates.laminate;
        var finishFactor=.75+(.25*finishRatio);
        total=basePackage*sizeFactor*finishFactor;
        summary=size.toUpperCase()+' Full Home · '+pkg.charAt(0).toUpperCase()+pkg.slice(1)+' Package';
      }else if(type==='kitchen'){
        var ks=checked('kitchen_size')||'compact';
        var area=kitchenArea[ks]||60;
        var kRate=kitchenRates[finish]||kitchenRates.laminate;
        total=area*kRate*(qualityFactor[pkg]||1);
        summary=(ks==='standard'?'10×10':ks.charAt(0).toUpperCase()+ks.slice(1))+' Kitchen · approx. '+area+' sq.ft';
      }else{
        var w=Math.max(4,Number(form.elements.wardrobe_width.value||8));
        var h=Math.max(6,Number(form.elements.wardrobe_height.value||8));
        var areaW=w*h;
        var wRate=wardrobeRates[finish]||wardrobeRates.laminate;
        total=areaW*wRate*(qualityFactor[pkg]||1);
        if((checked('wardrobe_door')||'hinged')==='sliding') total*=1.12;
        summary=w+'ft × '+h+'ft '+(checked('wardrobe_door')||'hinged')+' Wardrobe';
      }

      var low=total*.96;
      var high=total*1.04;
      var mrp=total/.62;
      var saving=Math.max(0,mrp-total);
      var off=mrp?Math.round(saving/mrp*100):0;
      var defaults=defaultsFromPackage(pkg);
      var materialOverride=checked('material_override')||'auto';
      var hardwareOverride=checked('hardware_override')||'auto';
      var material=materialOverride==='auto'?defaults.material:materialOverride;
      var hardware=hardwareOverride==='auto'?defaults.hardware:hardwareOverride;
      var rec=recommendation(pkg,finish);

      root.querySelector('[data-result-range]').textContent=money(low)+' – '+money(high);
      root.querySelector('[data-result-summary]').textContent=summary+' · '+(finish==='veneer'?(type==='wardrobe'?'GLASS / PREMIUM':'PREMIUM'):finish.toUpperCase());
      root.querySelector('[data-result-total]').textContent=money(total);
      root.querySelector('[data-result-mrp]').textContent=money(mrp);
      root.querySelector('[data-result-saving]').textContent=money(saving);
      root.querySelector('[data-result-off]').textContent='Approx. '+off+'% saving';
      root.querySelector('[data-recommendation]').textContent=rec.title;
      root.querySelector('[data-recommendation-note]').textContent=rec.note;

      var msg='Hi Right Work Interior, I used the Smart Interior Estimator.%0A%0A'+
        'Estimate: '+encodeURIComponent(money(low)+' – '+money(high))+'%0A'+
        'Right Work Estimate: '+encodeURIComponent(money(total))+'%0A'+
        'Estimated MRP: '+encodeURIComponent(money(mrp))+'%0A'+
        'Scope: '+encodeURIComponent(summary)+'%0A'+
        'Package: '+encodeURIComponent(pkg)+'%0A'+
        'Finish: '+encodeURIComponent(finish)+'%0A'+
        'Material: '+encodeURIComponent(material)+'%0A'+
        'Hardware: '+encodeURIComponent(hardware)+'%0A%0A'+
        'Please help me with a detailed quotation and final eligible offer.';
      root.querySelector('[data-whatsapp-estimate]').href='https://wa.me/919880064884?text='+msg;

      result.hidden=false;
      actions.hidden=true;
      steps.forEach(function(s){s.classList.remove('is-active');});
      result.scrollIntoView({behavior:'smooth',block:'start'});
    }

    function resetEstimator(){
      form.reset();
      setPanels();
      showStep(1);
    }

    root.querySelectorAll('[data-estimator-type]').forEach(function(btn){
      btn.addEventListener('click',function(){
        type=btn.dataset.estimatorType;
        resetEstimator();
        try{
          if(dialog.open&&typeof dialog.close==='function') dialog.close();
          if(typeof dialog.showModal==='function') dialog.showModal();
          else dialog.setAttribute('open','');
        }catch(e){dialog.setAttribute('open','');}
      });
    });

    close.addEventListener('click',function(){
      if(typeof dialog.close==='function'&&dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    });
    dialog.addEventListener('click',function(e){
      if(e.target===dialog){
        if(typeof dialog.close==='function'&&dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      }
    });
    next.addEventListener('click',function(){if(step<3) showStep(step+1); else calculate();});
    back.addEventListener('click',function(){if(step>1) showStep(step-1);});
    restart.addEventListener('click',resetEstimator);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
